import CreditCardFormViewController from './CreditCardFormViewController';

export default CreditCardFormViewController;
